export * from './baContentTop.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baContentTop/index.ts